<template>
  <div>
    <b-table
      ref="table"
      :fields="fields"
      :items="evidenceSubmissions"
      show-empty
      empty-text="No submitted Evidence"
      tbody-tr-class="row__submission"
      primary-key="id"
    >
      <template #head(select)>
        <b-form-checkbox
          v-show="false"
          v-model="allSelected"
          :indeterminate="indeterminate"
          @change="toggleAll"
        >
        </b-form-checkbox>
      </template>
      <template #cell(select)="data">
        <b-form-checkbox
          :id="`checkbox-submission-${data.item.id}`"
          v-model="$_selectedSubmissions"
          :name="`checkbox-submission-${data.item.id}`"
          :value="data.item.id"
          :disabled="data.item.assessor ? true : false"
        >
        </b-form-checkbox>
      </template>
      <template #cell(code)="data">
        <b-button variant="link" @click="openModal(data.item)">
          <span class="text__submission-id">{{ data.value }}</span>
        </b-button>
      </template>

      <template #cell(submitted_no)="data">
        <span class="text__submission-count">{{ data.value }}</span>
      </template>

      <template #cell(submitted_at)="data">
        <span class="text__submitted-date">{{ formatDate(data.value) }}</span>
      </template>

      <template #cell(status)="data">
        <span class="text__submission-status">
          {{ getStatusName(data.item) }}
        </span>
      </template>
      <template #cell(assessor)="data">
        <span v-if="data.item.assessor" class="text__assessor-name">
          {{ data.item.assessor.firstname }} {{ data.item.assessor.lastname }}
        </span>
        <span v-else class="text__assessor-name submission-assessor-unassign"> Unassigned </span>
      </template>
    </b-table>

    <!-- Pagination -->
    <b-pagination
      ref="pagination"
      v-model="$_currentPage"
      :total-rows="totalItems"
      :per-page="perPage"
      first-number
      last-number
      align="center"
    />

    <PreviewEvidenceSubmissionModal
      v-if="selectedEvidence"
      :evidence-submission-id="selectedEvidence.id"
      :learner-id="selectedEvidence.user"
      :learning-unit-id="selectedEvidence.learning_unit"
      :show.sync="showPreviewModal"
      @closeModal="closeModal()"
    />
  </div>
</template>

<script>
import moment from 'moment';
import EvidenceSubmission from '@/models/EvidenceSubmission';
import PreviewEvidenceSubmissionModal from './PreviewEvidenceSubmissionModal.vue';

export default {
  components: {
    PreviewEvidenceSubmissionModal
  },

  model: {
    prop: 'vModel',
    event: 'change'
  },

  props: {
    fields: {
      type: Array,
      default: () => [
        {
          key: 'select',
          label: '',
          thClass: 'bg-white'
        },
        {
          key: 'code',
          label: 'SUBMISSION ID',
          thClass: 'bg-white'
        },
        {
          key: 'submitted_no',
          label: 'SUBMITTED NO.',
          thClass: 'bg-white'
        },
        {
          key: 'submitted_at',
          label: 'SUBMITTED DATE',
          thClass: 'bg-white'
        },
        { key: 'status', label: 'STATUS', thClass: 'bg-white' },
        { key: 'assessor', label: 'ASSESSOR', thClass: 'bg-white' }
      ]
    },
    evidenceSubmissions: {
      type: Array,
      default: () => []
    },
    perPage: {
      type: Number,
      default: 1
    },
    totalItems: {
      type: Number,
      default: 0
    },
    vModel: {
      type: Number,
      default: 1,
      required: true
    },
    mode: {
      type: String,
      default: 'assessor'
    },
    selectedSubmissions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      allSelected: false,
      indeterminate: false,
      showPreviewModal: false,
      selectedEvidence: null
    };
  },

  computed: {
    $_currentPage: {
      get() {
        return this.vModel;
      },
      set(v) {
        return this.$emit('change', v);
      }
    },
    submissionReadyToCheck() {
      return this.evidenceSubmissions.filter((submission) => submission.assessor === null);
    },
    $_selectedSubmissions: {
      get() {
        return this.selectedSubmissions;
      },

      set(v) {
        this.$emit('update:selectedSubmissions', v);
      }
    }
  },

  watch: {
    $_selectedSubmissions(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.submissionReadyToCheck.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    }
  },

  methods: {
    toggleAll(checked) {
      this.$_selectedSubmissions = checked
        ? this.submissionReadyToCheck.map((submission) => submission.id).slice()
        : [];
    },
    formatDate(dateTime) {
      return moment(dateTime).format('MMM D, YYYY hh:mm a');
    },

    getStatusName(evidenceSubmission) {
      let statusName = EvidenceSubmission.STATUS[evidenceSubmission.status];

      if (this.mode === 'assessor' || this.mode === 'issuer') {
        if (!evidenceSubmission.assessor && evidenceSubmission.status == 'REVIEW_PENDING') {
          statusName = 'Submitted';
        } else if (!evidenceSubmission.assessor_reviewed_at) {
          statusName = EvidenceSubmission.STATUS.IN_PROGRESS_BY_ASSESSOR;
        } else if (
          evidenceSubmission.assessor_reviewed_at &&
          !evidenceSubmission.issuer_reviewed_at
        ) {
          statusName = EvidenceSubmission.STATUS.IN_PROGRESS_BY_ISSUER;
        }
      }

      return statusName;
    },

    async openModal(evidenceSubmission) {
      this.selectedEvidence = evidenceSubmission;
      this.showPreviewModal = true;
    },

    async closeModal() {
      this.showPreviewModal = false;
      this.selectedEvidence = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.text__assessor-name {
  padding: 0px 12px 0px 12px;
  gap: 8px;
  border-radius: 3.2px 0px 0px 0px;
  background-color: #f5f5f7;
  color: #7a7b97;
}
.text__submission-id {
  user-select: text;
  text-decoration: underline;
}
input[type='checkbox'] {
  appearance: none;
  border-radius: 20%;
  border: 1px solid rgb(207, 207, 207);
}
input[type='checkbox']:checked::before {
  transform: scale(1);
}
input[type='checkbox']::before {
  content: '\f00c'; /* Font Awesome checkmark icon (replace if needed) */
  font-family: FontAwesome;

  width: 1rem;
  height: 1rem;
  display: flex;
  transform: scale(0);
  font-size: 12px;
  align-content: center;
  text-align: center;
  padding-left: 2px;
  background-color: #3c44b1;
  color: #ffffff;
}
</style>
